<template>
  <v-card color="secondary" class="mt-1" flat>
    <v-card-title>
      <span class="subtitle-1">
        <span class="pr-1">Assign "{{personName}}" to cast and crew of</span>
        <fid-chip
            :itemReason="reason"
        ></fid-chip> 
      </span>
      <v-spacer></v-spacer>
      <v-btn icon  @click="showContent=!showContent">
        <v-icon :color=showIconColor>{{showIcon}}</v-icon>
      </v-btn>
    </v-card-title>

    <v-data-table
        v-if="items && showContent"
        :items="items"
        hide-default-footer
        :hide-default-header="Boolean(this.showItem)"
        :headers="headers"
        :no-data-text="loading ? 'fetching' : 'No potential matches found'"
        :items-per-page="(items && items.length) || 10"
        disable-sort
      >
        <template v-slot:item="{item}">
          <callsheet-analysis-assign-row 
            :matchingRow="item"  
            :reason="reason"
            :showItem="showItem"
            :targetItem="targetItem"
            @showing="showing"
            @pick="pick"
          >
          </callsheet-analysis-assign-row>
        </template>
    </v-data-table>

    <v-card-actions v-if="!showItem && showContent">

          <v-row>
            <v-col>
              <v-dialog v-model="updateDialog" persistent >
                <template #activator="{ on: dialog }">
                  <v-tooltip
                    right 
                    content-class="caption" 
                    transition="slide-x-transition"
                  >
                    <template #activator="{ on: tooltip }">
                      <v-btn
                        fab
                        bottom
                        left
                        small
                        color="accent"
                        v-on="{ 
                        ...tooltip, 
                        ...dialog 
                        }" 
                      
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                      <span class="pl-2">Can't find {{personName}}? Add a new basic profile</span>
                    </template>
                    <span class="caption">Add a new {{personName}}</span>
                  </v-tooltip>
                </template>
               
                <add-person-dialog 
                  :split-name="splitName"
                  @cancel="cancelAddPerson"
                  @save="saveAddPerson"
                >
                </add-person-dialog>
              
              </v-dialog>
            </v-col>

          </v-row>

     
    </v-card-actions>
    
  </v-card>


</template>
<script>
import { getIconColor, getIcon } from '@/js/store'
import { SearcherResult } from '@/gql'
import { SearchUtils } from '@/js'
import Fidchip from '@/components/Fidchip'
import Addpersondialog from '@/components/Addpersondialog'
import Callsheetanalysisassignrow from '@/components/Callsheetanalysisassignrow'
import { updateCallsheetAnalysisGql, createPersonGql } from '@/js/mutations'
import { showToaster } from '@/js/apollo'
export default {
  props: {
    targetItem: Object,
    reason: Object
  },
  components: {
    'callsheet-analysis-assign-row': Callsheetanalysisassignrow,
    'fid-chip': Fidchip,
    'add-person-dialog': Addpersondialog
  },

  methods: {
    prettyName (data) {
      return SearchUtils.getPersonName ({item: {
        Person: data
      }})
    },
    addPerson (data) {
      return createPersonGql({
        apolloClient: this.$apollo,
        data
      })
      .then(p=> {
        showToaster({
          header: 'success', 
          type: 'success',
          message: `Added person ${this.prettyName(p)}`
        })
        return p
      })
      .catch(err=> {
        showToaster({ 
          header: 'error', 
          type: 'error',
          message: err 
        })
      })   
    },
    cancelAddPerson () {
      this.updateDialog = false
    },
    saveAddPerson (person) {
      this.updateDialog = false
      // first add person then fake an entry for him in the analysis
      return this.addPerson (person)
        .then (p=>this.updateCan({
          id: this.targetItem.id,
          personID: p.id
        }))
        .finally(()=>{
        // .. any tidy up
        })
    },
    updateCan (data) {
      return updateCallsheetAnalysisGql({
        apolloClient: this.$apollo,
        data
      })
      .catch(err=> {
        showToaster({ 
          header: 'error', 
          type: 'error',
          message: err 
        })
      })
      .finally(()=>{
        // any tidy up...
      })
    },
    pick ({id, personID }) {
      // this triggers settings the personID in the Callsheetanalysisassignrow
      return this.updateCan({id, personID})      
    },
    // and showitem will be the matchingrow that was selected or null if its been closed
    showing (showItem) {
      this.showItem = showItem
      this.$emit('hideclose', this.showItem )
    },
    registerResult (data) {
      this.SearcherResult = data && data.SearcherResult
      const fetchedRows = ( this.SearcherResult && this.SearcherResult.Searchers) || []
      this.totalFetched = fetchedRows.length
      SearchUtils.optimizeFetched({ fetched: fetchedRows })
      fetchedRows.forEach(d => {
        // we're looking for something like filmID
        const idField = d.itemType + 'ID'
        d.itemReason = d.MatchReasons.find(f => f[idField] === d.itemID)
        if (!d.itemReason) {
          console.log(`itemtable: failed to find itemreason for ${idField}`, d)
        }
        if (d.itemType !== this.targetType) {
           console.log(`itemtable:expected ${this.targetType} but got ${fetchedRows.map(f => f.itemType).join(',')}`)
        }
      })
      // cause a refresh
      // these are all the potential matches for the person name
      this.items = fetchedRows ? JSON.parse(JSON.stringify(fetchedRows)) : fetchedRows
    }
  },
  data: () => ({
    updateDialog: false,
    showItem: null,
    showContent: false,
    SearcherResult: null,
    // TODO is 20 enough to always find someone?
    limit: 20,
    items: null,
    targetType: 'person'
  }),
  computed: {
    callsheetID () {
      return this.targetItem && this.targetItem.callsheetID
    },
    splitName () {
      return SearchUtils.splitFullName ({text: this.personName})
    },
    headers () {
      return this.showItem ? [{ text: 'Assigning to film', value: 'itemID'}] : [
        { text: 'Confirm'},
        { text: 'Possible match', value: 'itemID'},
        { text: 'Reasons', value: 'matchReasons'},
        { text: 'Already assigned to film', value: 'personID' }
      ]
    },
    loading () {
      return this.$apollo.loading
    },    
    queryVars () {
      const q = {
        value: this.queryContent,
        limit: this.limit,
        offset: 0,
        itemType: 'person',
        searcherType: 'ELASTIC',
        queryType: 'csperson',
        elIncludes: this.queryIncludes
      }
      
      return q;
    },
    queryItems () {

      return this.targetItem && [
        'personID',
        'person',
        'profession',
        'company',
        'mobile',
        'phone',
        'email'
      ].reduce((p,c) => {
        const value = c === 'phone' || c == 'mobile' ? this.targetItem[c].replace(/\s/g,'') : this.targetItem[c]
        if(value) {

          const ob = ({
            key: c,
            value: value.split(' ').map(f=>this.queryFieldMap[c].map(g=>`${g}:${f}`).join(" ")).join(" ")
          });
          p.push(ob)
        }
        return p
      }, [])
    },
    queryContent () {
      return this.queryItems.map(f=>f.value).join(" ")
    },
    queryFieldMap () {
      // the presence of theses fields drives what to query on
      return {
        personID: ['csperson-person-id'],
        person: ['csperson-person-name'],
        mobile: ['csperson-contact-mobile'],
        phone: ['csperson-contact-phone'],
        email: ['csperson-contact-email'],
        company: [
          'csperson-company-name', 
          'csperson-company-abbreviated-name',
          'csperson-company-local-name',
          'csperson-company-local-abbreviated-name'
        ],   
        profession: ['csperson-film-profession-name']   
      }
    },
    queryIncludes () {
      // the idea here is only to include searches in keys where we actually have some data
      const q = this.queryItems.reduce((p,c)=>{
        const t = this.queryFieldMap[c.key]
        if (!t) {
          console.error('couldnt find field for',c)
        } else {
          [].push.apply(p, t.map(f=>({
            key:f
          })))
        }
        return p;
      },[])
      // now special patch to look in companies professions too (these are indistinguishable in cal sheet analysis from film professions)
      const c = this.queryItems.find(f=>f.key === 'company')
      const p = this.queryItems.find(f=>f.key === 'profession')
      if (p && c) q.push({
        key: 'csperson-company-profession-name'
      })
      return q
    },
    showIcon () {
      return getIcon(this.showContent ? 'hide' : 'show')
    },
    showIconColor () {
      return getIconColor(this.showContent ? 'hide' : 'show')
    },
    personName () {
      return this.targetItem.person
    }
  },
  apollo: {
    SearcherResult: {
      query: SearcherResult,
      variables () {
        return this.queryVars
      },
      skip () {
        // don't want to do this if not ready
        return !this.queryVars
      },
      result (result) {
        // this actually handles registration of data for both new and get more stuff
        this.registerResult(result && result.data)
      }
    }
  }
}
</script>
